export const DEFAULT_VALUES = {
  FIRE_GENERAL: 26,
  OTHER_INSURER: 17,
  OTHER_PRODUCT: 7,
  SELECTED: 0,
};
